/**
 * FlashSVG — the inline SVG flashlight illustration.
 *
 * Renders at the size of its parent container. Used inside FlashlightCard.
 */
export default function FlashSVG() {
  return (
    <svg
      viewBox="0 0 48 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '100%', height: '100%' }}
    >
      <rect x="16" y="0" width="16" height="10" rx="3" fill="#888" />
      <rect x="14" y="10" width="20" height="8" rx="2" fill="#999" />
      <polygon points="10,18 38,18 42,38 6,38" fill="#aaa" />
      <ellipse cx="24" cy="38" rx="18" ry="6" fill="#ddd" />
      <rect x="8" y="38" width="32" height="50" rx="6" fill="#555" />
      <rect x="10" y="40" width="28" height="3" rx="1" fill="#666" />
      <rect x="10" y="76" width="28" height="3" rx="1" fill="#666" />
      <rect x="12" y="55" width="24" height="14" rx="3" fill="#444" />
      <circle cx="24" cy="38" r="14" fill="#fefce8" opacity="0.7" />
      <circle cx="24" cy="38" r="8" fill="#fff" opacity="0.9" />
    </svg>
  )
}
